export default __webpack_public_path__ + "static/media/kitchen3-after2-1920w.2d9486e5.png";